@for (notification of notifications(); track trackByID($index, notification)) {
  @if (notification) {
    <ph-notification
      (closed)="closeNotification($event)"
      [duration]="notification.duration!"
      [actions]="notification.actions!"
      [value]="notification.value"
      [type]="notification.type"
      [id]="notification?.id ?? ''"
      [standalone]="false"
      @notificationReveal
    />
  }
}
